import { render, staticRenderFns } from "./TabelaAlunosSemTurma.vue?vue&type=template&id=3610fa77&"
import script from "./TabelaAlunosSemTurma.vue?vue&type=script&lang=js&"
export * from "./TabelaAlunosSemTurma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports